module.exports = __webpack_public_path__ + "img/epp-logo.ad82a3a9.svg";